import { combineReducers } from 'redux';
import { createReducer } from '@reduxjs/toolkit';
import {
  addContactRequest,
  addContactSuccess,
  addContactError,
  deleteContactRequest,
  deleteContactSuccess,
  deleteContactError,
  fetchContactsRequest,
  fetchContactsSuccess,
  fetchContactsError,
  editContactRequest,
  editContactSuccess,
  editContactError,
  changeFilter,
  setTotalContacts,
  setTotalPages,
  setContactsLimit,
  setPage,
  updateTotalContacts,
} from './contacts-actions';

const items = createReducer([], {
  [fetchContactsSuccess]: (_, { payload }) => payload,
  [addContactSuccess]: (_, { payload }) => [...payload],
  [deleteContactSuccess]: (state, { payload }) =>
    state.filter(contact => contact._id !== payload),
  [editContactSuccess]: (state, { payload }) =>
    state.map(contact => (contact._id === payload._id ? payload : contact)),
});

const filter = createReducer('', {
  [changeFilter]: (_, { payload }) => payload,
});

const loading = createReducer(false, {
  [fetchContactsRequest]: () => true,
  [fetchContactsSuccess]: () => false,
  [fetchContactsError]: () => false,
  [addContactRequest]: () => true,
  [addContactSuccess]: () => false,
  [addContactError]: () => false,
  [deleteContactRequest]: () => true,
  [deleteContactError]: () => false,
  [editContactRequest]: () => true,
  [editContactSuccess]: () => false,
  [editContactError]: () => false,
});

const page = createReducer(1, {
  [setPage]: (_, { payload }) => payload,
});

const totalContacts = createReducer(0, {
  [setTotalContacts]: (_, { payload }) => payload,
  [updateTotalContacts]: state => state + 1,
});

const limit = createReducer(0, {
  [setContactsLimit]: (_, { payload }) => payload,
});

const totalPages = createReducer(0, {
  [setTotalPages]: (_, { payload }) => payload,
});

export default combineReducers({
  items,
  filter,
  loading,
  totalContacts,
  page,
  limit,
  totalPages,
});
